class MultiPackToggle extends HTMLElement {
  connectedCallback() {
    this.options = Array.from(this.querySelectorAll('[data-multi-pack-qty]'));
    this.options.forEach((opt) => {
      opt.addEventListener('click', () => this.select(opt));
    });
  }

  findForm() {
    return (
      this.closest('form.js-product-form') ||
      document.querySelector('form.js-product-form')
    );
  }

  select(opt) {
    const qty = opt.dataset.multiPackQty;
    this.options.forEach((o) => {
      o.setAttribute('aria-pressed', o === opt ? 'true' : 'false');
    });
    this.updateForm(qty);
  }

  updateForm(qty) {
    const form = this.findForm();
    if (!form) return;

    let qtyInput = form.querySelector('input[name="quantity"]');
    if (!qtyInput) {
      qtyInput = document.createElement('input');
      qtyInput.type = 'hidden';
      qtyInput.name = 'quantity';
      form.appendChild(qtyInput);
    }
    qtyInput.value = qty;
    qtyInput.dispatchEvent(new Event('change', { bubbles: true }));

    const buyNow = form.querySelector('.button--checkout');
    if (buyNow) {
      buyNow.href = buyNow.href.replace(/:\d+(\?|$)/, `:${qty}$1`);
    }
  }
}

if (!customElements.get('multi-pack-toggle')) {
  customElements.define('multi-pack-toggle', MultiPackToggle);
}
